(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlinx-html-js', 'kotlinx-coroutines-core'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlinx-html-js'), require('kotlinx-coroutines-core'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'example-frontend'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'example-frontend'.");
    }
    if (typeof this['kotlinx-html-js'] === 'undefined') {
      throw new Error("Error loading module 'example-frontend'. Its dependency 'kotlinx-html-js' was not found. Please, check whether 'kotlinx-html-js' is loaded prior to 'example-frontend'.");
    }
    if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'example-frontend'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'example-frontend'.");
    }
    root['example-frontend'] = factory(typeof this['example-frontend'] === 'undefined' ? {} : this['example-frontend'], kotlin, this['kotlinx-html-js'], this['kotlinx-coroutines-core']);
  }
}(this, function (_, Kotlin, $module$kotlinx_html_js, $module$kotlinx_coroutines_core) {
  'use strict';
  var println = Kotlin.kotlin.io.println_s8jyv4$;
  var Unit = Kotlin.kotlin.Unit;
  var ensureNotNull = Kotlin.ensureNotNull;
  var throwCCE = Kotlin.throwCCE;
  var get_append = $module$kotlinx_html_js.kotlinx.html.dom.get_append_y4uc6z$;
  var h1 = $module$kotlinx_html_js.kotlinx.html.h1_vmej1w$;
  var set_onClickFunction = $module$kotlinx_html_js.kotlinx.html.js.set_onClickFunction_pszlq2$;
  var button = $module$kotlinx_html_js.kotlinx.html.button_whohl6$;
  var div = $module$kotlinx_html_js.kotlinx.html.div_ri36nr$;
  var set_id = $module$kotlinx_html_js.kotlinx.html.set_id_ueiko3$;
  var div_0 = $module$kotlinx_html_js.kotlinx.html.div_59el9d$;
  var CoroutineImpl = Kotlin.kotlin.coroutines.experimental.CoroutineImpl;
  var COROUTINE_SUSPENDED = Kotlin.kotlin.coroutines.experimental.intrinsics.COROUTINE_SUSPENDED;
  var launch = $module$kotlinx_coroutines_core.kotlinx.coroutines.experimental.launch_ej4974$;
  var math = Kotlin.kotlin.math;
  var coerceAtMost = Kotlin.kotlin.ranges.coerceAtMost_38ydlf$;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var awaitAnimationFrame = $module$kotlinx_coroutines_core.kotlinx.coroutines.experimental.awaitAnimationFrame_nz12v2$;
  function main$lambda(it) {
    (new Application()).start();
    return Unit;
  }
  function main(args) {
    println('Starting example application...');
    document.addEventListener('DOMContentLoaded', main$lambda);
  }
  function get_px($receiver) {
    return $receiver.toString() + 'px';
  }
  function setSize($receiver, w, h) {
    var $receiver_0 = $receiver.style;
    $receiver_0.width = get_px(w);
    $receiver_0.height = get_px(h);
  }
  function setPosition($receiver, x, y) {
    var $receiver_0 = $receiver.style;
    $receiver_0.left = get_px(x);
    $receiver_0.top = get_px(y);
  }
  function random() {
    return Math.random();
  }
  var LinkedHashSet_init = Kotlin.kotlin.collections.LinkedHashSet_init_287e2$;
  function Application() {
    this.sw_0 = 800.0;
    this.sh_0 = 600.0;
    this.animationIndex_0 = 0;
    this.animations_0 = LinkedHashSet_init();
  }
  Object.defineProperty(Application.prototype, 'body_0', {get: function () {
    return ensureNotNull(document.body);
  }});
  Object.defineProperty(Application.prototype, 'scene_0', {get: function () {
    var tmp$;
    return Kotlin.isType(tmp$ = document.getElementById('scene'), HTMLElement) ? tmp$ : throwCCE();
  }});
  function Application$start$lambda$lambda($receiver) {
    $receiver.unaryPlus_pdl1vz$('Kotlin Coroutines JS Example');
    return Unit;
  }
  function Application$start$lambda$lambda$lambda$lambda(this$Application) {
    return function (it) {
      this$Application.onRect_0();
      return Unit;
    };
  }
  function Application$start$lambda$lambda$lambda(this$Application) {
    return function ($receiver) {
      $receiver.unaryPlus_pdl1vz$('Rect');
      set_onClickFunction($receiver, Application$start$lambda$lambda$lambda$lambda(this$Application));
      return Unit;
    };
  }
  function Application$start$lambda$lambda$lambda$lambda_0(this$Application) {
    return function (it) {
      this$Application.onCircle_0();
      return Unit;
    };
  }
  function Application$start$lambda$lambda$lambda_0(this$Application) {
    return function ($receiver) {
      $receiver.unaryPlus_pdl1vz$('Circle');
      set_onClickFunction($receiver, Application$start$lambda$lambda$lambda$lambda_0(this$Application));
      return Unit;
    };
  }
  function Application$start$lambda$lambda$lambda$lambda_1(this$Application) {
    return function (it) {
      this$Application.onClear_0();
      return Unit;
    };
  }
  function Application$start$lambda$lambda$lambda_1(this$Application) {
    return function ($receiver) {
      $receiver.unaryPlus_pdl1vz$('Clear');
      set_onClickFunction($receiver, Application$start$lambda$lambda$lambda$lambda_1(this$Application));
      return Unit;
    };
  }
  function Application$start$lambda$lambda_0(this$Application) {
    return function ($receiver) {
      button($receiver, void 0, void 0, void 0, void 0, Application$start$lambda$lambda$lambda(this$Application));
      button($receiver, void 0, void 0, void 0, void 0, Application$start$lambda$lambda$lambda_0(this$Application));
      button($receiver, void 0, void 0, void 0, void 0, Application$start$lambda$lambda$lambda_1(this$Application));
      return Unit;
    };
  }
  function Application$start$lambda$lambda_1($receiver) {
    set_id($receiver, 'scene');
    return Unit;
  }
  function Application$start$lambda(this$Application) {
    return function ($receiver) {
      h1($receiver, void 0, Application$start$lambda$lambda);
      div($receiver, void 0, Application$start$lambda$lambda_0(this$Application));
      div($receiver, void 0, Application$start$lambda$lambda_1);
      return Unit;
    };
  }
  Application.prototype.start = function () {
    div_0(get_append(this.body_0), 'content', Application$start$lambda(this));
    setSize(this.scene_0, this.sw_0, this.sh_0);
  };
  function Application$animation$lambda(closure$block_0, closure$elem_0) {
    return function ($receiver_0, continuation_0, suspended) {
      var instance = new Coroutine$Application$animation$lambda(closure$block_0, closure$elem_0, $receiver_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function Coroutine$Application$animation$lambda(closure$block_0, closure$elem_0, $receiver_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 1;
    this.local$closure$block = closure$block_0;
    this.local$closure$elem = closure$elem_0;
    this.local$$receiver = $receiver_0;
  }
  Coroutine$Application$animation$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$Application$animation$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$Application$animation$lambda.prototype.constructor = Coroutine$Application$animation$lambda;
  Coroutine$Application$animation$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = this.local$closure$block(this.local$$receiver, this.local$closure$elem, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            return this.result_0;
        }
      }
       catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        }
         else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function Application$animation$lambda_0(this$Application, closure$job, closure$elem) {
    return function (it) {
      var $receiver = this$Application.animations_0;
      var element = closure$job;
      $receiver.remove_11rb$(element);
      this$Application.scene_0.removeChild(closure$elem);
      return Unit;
    };
  }
  Application.prototype.animation_0 = function (cls, size, block) {
    var elem = div_0(get_append(this.scene_0), cls);
    setSize(elem, size, size);
    var job = launch(void 0, void 0, void 0, Application$animation$lambda(block, elem));
    this.animations_0.add_11rb$(job);
    job.invokeOnCompletion_ct2b2z$(void 0, void 0, Application$animation$lambda_0(this, job, elem));
  };
  var Math_0 = Math;
  function Application$onRect$lambda(closure$index_0, closure$turnAfter_0, closure$speed_0, closure$maxX_0, closure$maxY_0) {
    return function ($receiver, rect_0, continuation_0, suspended) {
      var instance = new Coroutine$Application$onRect$lambda(closure$index_0, closure$turnAfter_0, closure$speed_0, closure$maxX_0, closure$maxY_0, $receiver, rect_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function Coroutine$Application$onRect$lambda(closure$index_0, closure$turnAfter_0, closure$speed_0, closure$maxX_0, closure$maxY_0, $receiver, rect_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 1;
    this.local$closure$index = closure$index_0;
    this.local$closure$turnAfter = closure$turnAfter_0;
    this.local$closure$speed = closure$speed_0;
    this.local$closure$maxX = closure$maxX_0;
    this.local$closure$maxY = closure$maxY_0;
    this.local$timer = void 0;
    this.local$turnTime = void 0;
    this.local$turnTimePhase = void 0;
    this.local$vx = void 0;
    this.local$vy = void 0;
    this.local$x = void 0;
    this.local$y = void 0;
    this.local$rect = rect_0;
  }
  Coroutine$Application$onRect$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$Application$onRect$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$Application$onRect$lambda.prototype.constructor = Coroutine$Application$onRect$lambda;
  Coroutine$Application$onRect$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            println("Started new 'rect' coroutine #" + this.local$closure$index);
            this.local$timer = new AnimationTimer();
            this.local$turnTime = this.local$timer.time + this.local$closure$turnAfter;
            var tmp$ = this.local$turnTime;
            var x = this.local$turnTime / this.local$closure$turnAfter;
            this.local$turnTimePhase = tmp$ - Math_0.floor(x) * this.local$closure$turnAfter;
            this.local$vx = this.local$closure$speed;
            this.local$vy = this.local$closure$speed;
            this.local$x = 0.0;
            this.local$y = 0.0;
            this.state_0 = 2;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            this.state_0 = 3;
            this.result_0 = this.local$timer.await(this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 3:
            var dt = this.result_0;
            this.local$x += this.local$vx * dt;
            this.local$y += this.local$vy * dt;
            if (this.local$x > this.local$closure$maxX.v) {
              this.local$x = 2 * this.local$closure$maxX.v - this.local$x;
              this.local$vx = -this.local$vx;
            }

            if (this.local$x < 0) {
              this.local$x = -this.local$x;
              this.local$vx = -this.local$vx;
            }

            if (this.local$y > this.local$closure$maxY) {
              this.local$y = 2 * this.local$closure$maxY - this.local$y;
              this.local$vy = -this.local$vy;
            }

            if (this.local$y < 0) {
              this.local$y = -this.local$y;
              this.local$vy = -this.local$vy;
            }

            setPosition(this.local$rect, this.local$x, this.local$y);
            if (this.local$timer.time >= this.local$turnTime) {
              this.state_0 = 4;
              this.result_0 = this.local$timer.delay_za3lpa$(1000, this);
              if (this.result_0 === COROUTINE_SUSPENDED)
                return COROUTINE_SUSPENDED;
              continue;
            }
             else {
              this.state_0 = 5;
              continue;
            }

          case 4:
            var t = this.local$vx;
            if (random() > 0.5) {
              this.local$vx = this.local$vy;
              this.local$vy = -t;
            }
             else {
              this.local$vx = -this.local$vy;
              this.local$vy = t;
            }

            var x_0 = this.local$timer.reset() / this.local$closure$turnAfter;
            this.local$turnTime = Math_0.ceil(x_0) * this.local$closure$turnAfter + this.local$turnTimePhase;
            println('Delayed #' + this.local$closure$index + ' for a while at ' + this.local$timer.time + ', resumed and turned');
            this.state_0 = 5;
            continue;
          case 5:
            this.state_0 = 2;
            continue;
        }
      }
       catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        }
         else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  Application.prototype.onRect_0 = function () {
    var index = (this.animationIndex_0 = this.animationIndex_0 + 1 | 0, this.animationIndex_0);
    var speed = 0.3;
    var rs = 20.0;
    var turnAfter = 5000.0;
    var maxX = {v: this.sw_0 - rs};
    var maxY = this.sh_0 - rs;
    this.animation_0('rect', rs, Application$onRect$lambda(index, turnAfter, speed, maxX, maxY));
  };
  function Application$onCircle$lambda(closure$index_0, closure$initialSpeed_0, closure$initialRange_0, this$Application_0, closure$acceleration_0, closure$maxSpeed_0) {
    return function ($receiver, circle_0, continuation_0, suspended) {
      var instance = new Coroutine$Application$onCircle$lambda(closure$index_0, closure$initialSpeed_0, closure$initialRange_0, this$Application_0, closure$acceleration_0, closure$maxSpeed_0, $receiver, circle_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function Coroutine$Application$onCircle$lambda(closure$index_0, closure$initialSpeed_0, closure$initialRange_0, this$Application_0, closure$acceleration_0, closure$maxSpeed_0, $receiver, circle_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 1;
    this.local$closure$index = closure$index_0;
    this.local$closure$initialSpeed = closure$initialSpeed_0;
    this.local$closure$initialRange = closure$initialRange_0;
    this.local$this$Application = this$Application_0;
    this.local$closure$acceleration = closure$acceleration_0;
    this.local$closure$maxSpeed = closure$maxSpeed_0;
    this.local$timer = void 0;
    this.local$vx = void 0;
    this.local$vy = void 0;
    this.local$x = void 0;
    this.local$y = void 0;
    this.local$circle = circle_0;
  }
  Coroutine$Application$onCircle$lambda.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$Application$onCircle$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$Application$onCircle$lambda.prototype.constructor = Coroutine$Application$onCircle$lambda;
  Coroutine$Application$onCircle$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            println("Started new 'circle' coroutine #" + this.local$closure$index);
            this.local$timer = new AnimationTimer();
            var initialAngle = random() * 2 * math.PI;
            this.local$vx = Math_0.sin(initialAngle) * this.local$closure$initialSpeed;
            this.local$vy = Math_0.cos(initialAngle) * this.local$closure$initialSpeed;
            this.local$x = (random() * this.local$closure$initialRange + (1 - this.local$closure$initialRange) / 2) * this.local$this$Application.sw_0;
            this.local$y = (random() * this.local$closure$initialRange + (1 - this.local$closure$initialRange) / 2) * this.local$this$Application.sh_0;
            this.state_0 = 2;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            this.state_0 = 3;
            this.result_0 = this.local$timer.await(this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 3:
            var dt = this.result_0;
            var dx = this.local$this$Application.sw_0 / 2 - this.local$x;
            var dy = this.local$this$Application.sh_0 / 2 - this.local$y;
            var x = dx * dx + dy * dy;
            var dn = Math_0.sqrt(x);
            this.local$vx += dx / dn * this.local$closure$acceleration * dt;
            this.local$vy += dy / dn * this.local$closure$acceleration * dt;
            var x_0 = this.local$vx * this.local$vx + this.local$vy * this.local$vy;
            var vn = Math_0.sqrt(x_0);
            var trim = coerceAtMost(vn, this.local$closure$maxSpeed);
            this.local$vx = this.local$vx / vn * trim;
            this.local$vy = this.local$vy / vn * trim;
            this.local$x += this.local$vx * dt;
            this.local$y += this.local$vy * dt;
            setPosition(this.local$circle, this.local$x, this.local$y);
            this.state_0 = 2;
            continue;
        }
      }
       catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        }
         else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  Application.prototype.onCircle_0 = function () {
    var index = (this.animationIndex_0 = this.animationIndex_0 + 1 | 0, this.animationIndex_0);
    var acceleration = 5.0E-4;
    var initialRange = 0.7;
    var maxSpeed = 0.4;
    var initialSpeed = 0.1;
    var radius = 20.0;
    this.animation_0('circle', radius, Application$onCircle$lambda(index, initialSpeed, initialRange, this, acceleration, maxSpeed));
  };
  Application.prototype.onClear_0 = function () {
    var tmp$;
    tmp$ = this.animations_0.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      element.cancel_dbl4no$();
    }
  };
  Application.$metadata$ = {kind: Kind_CLASS, simpleName: 'Application', interfaces: []};
  function AnimationTimer() {
    this.time = window.performance.now();
  }
  AnimationTimer.prototype.await = function (continuation_0, suspended) {
    var instance = new Coroutine$await(this, continuation_0);
    if (suspended)
      return instance;
    else
      return instance.doResume(null);
  };
  function Coroutine$await($this, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.$this = $this;
  }
  Coroutine$await.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$await.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$await.prototype.constructor = Coroutine$await;
  Coroutine$await.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.state_0 = 2;
            this.result_0 = awaitAnimationFrame(window, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            var newTime = this.result_0;
            var dt = newTime - this.$this.time;
            this.$this.time = newTime;
            return coerceAtMost(dt, 200.0);
        }
      }
       catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        }
         else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  AnimationTimer.prototype.reset = function () {
    this.time = window.performance.now();
    return this.time;
  };
  AnimationTimer.prototype.delay_za3lpa$ = function (i_0, continuation_0, suspended) {
    var instance = new Coroutine$delay_za3lpa$(this, i_0, continuation_0);
    if (suspended)
      return instance;
    else
      return instance.doResume(null);
  };
  function Coroutine$delay_za3lpa$($this, i_0, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.exceptionState_0 = 1;
    this.$this = $this;
    this.local$tmp$ = void 0;
    this.local$dt = void 0;
    this.local$i = i_0;
  }
  Coroutine$delay_za3lpa$.$metadata$ = {kind: Kotlin.Kind.CLASS, simpleName: null, interfaces: [CoroutineImpl]};
  Coroutine$delay_za3lpa$.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$delay_za3lpa$.prototype.constructor = Coroutine$delay_za3lpa$;
  Coroutine$delay_za3lpa$.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.local$dt = 0.0;
            this.state_0 = 2;
            continue;
          case 1:
            throw this.exception_0;
          case 2:
            if (this.local$dt >= this.local$i) {
              this.state_0 = 4;
              continue;
            }

            this.local$tmp$ = this.local$dt;
            this.state_0 = 3;
            this.result_0 = this.$this.await(this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 3:
            this.local$dt = this.local$tmp$ + this.result_0;
            this.state_0 = 2;
            continue;
          case 4:
            return;
        }
      }
       catch (e) {
        if (this.state_0 === 1) {
          this.exceptionState_0 = this.state_0;
          throw e;
        }
         else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  AnimationTimer.$metadata$ = {kind: Kind_CLASS, simpleName: 'AnimationTimer', interfaces: []};
  _.main_kand9s$ = main;
  _.get_px_yrwdxr$ = get_px;
  _.Application = Application;
  _.AnimationTimer = AnimationTimer;
  main([]);
  return _;
}));

//# sourceMappingURL=example-frontend.js.map



//////////////////
// WEBPACK FOOTER
// ./kotlin-js-min/main/example-frontend.js
// module id = 2
// module chunks = 0